import React from 'react'
import { connect } from 'react-redux';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import qs from 'qs';
import {
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getOperadorEmpresa,
    getGestorOperacoes,
    getPerfisVendedores,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import Titulo from '../comum/Titulo';
import buscarMapaViagem from '../../actions/itinerario/buscarMapaViagem';
import buscarItinerario from '../../actions/itinerario/buscarItinerario';
import { tipoImpressaoCupom } from '../../util/constantsUtil';
import ModalImpressaoMapaViagemItinerario from './ModalImpressaoMapaViagemItinerario';
import ReciboMapaViagem from './ReciboMapaViagem';

export class PainelMapaViagemItinerario extends React.Component {
    constructor(props) {
        super(props);
        this.handleChecked = this.handleChecked.bind(this);

        this.state = {
            eHmapaViagemPessoa: true,
            retorno: '/painel-itinerarios',
            isOpenModal: false,
            tipoImpressaoCupom: tipoImpressaoCupom.normal,
            pagina: null,
            referencias: null,
            referenciaSelecionada: 'MAPA_VIAGEM'
        }
    }

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        if (parametros.tipo == 'embarque') {
            this.setState({ retorno: '/painel-embarque-passageiros' })
        }
        if (parametros.itinerario) {
            this.props.buscarItinerario(this.props.empresaSelecionada.id, parametros.itinerario)
            this.props.buscarMapaViagem(parametros.itinerario, this.props.empresaSelecionada.id);
            this.setState({pagina: window});
            this.getReferencias();
        } else {
            this.props.history.push('/painel-itinerarios');
        }
    }

    getReferencias() {
        const ref = new Map();
        ref.set('MAPA_VIAGEM', {
            id: 'mapa_viagem',
            nome: 'Mapa Viagem Itinerario',
            nomeParaImpressao: 'mapa viagem itinerário',
            referencia: React.createRef()
        })
        ref.set('MAPA_VIAGEM_ENCOMENDA', {
            id: 'mapa_viagem_encomenda',
            nome: 'Mapa Viagem Encomenda',
            nomeParaImpressao: 'mapa viagem encomenda',
            referencia: React.createRef()
        });

        this.setState({referencias: ref})
    }

    setTipoImpressaoCupom(tipo) {    
        this.setState({ tipoImpressaoCupom: tipo })
    }

    habilitarDesabilitarModalReciboCupom(valor) {
        this.setState({ isOpenModal: valor })
    }

    apresentarReciboCupomTermica() {
        return this.state.isOpenModal && this.state.tipoImpressaoCupom == tipoImpressaoCupom.termica;
    }

    handleChecked() {
        let referenciaSelecionada = null;
        if (this.state.eHmapaViagemPessoa) {
            referenciaSelecionada = 'MAPA_VIAGEM_ENCOMENDA';
        } else {
            referenciaSelecionada = 'MAPA_VIAGEM';
        }
        this.setState({ eHmapaViagemPessoa: !this.state.eHmapaViagemPessoa, referenciaSelecionada: referenciaSelecionada  });
    }

    exibirCheckbox() {
        return (
            <React.Fragment>
                <div className='form-check'>
                    <input className='form-check-input' type="checkbox" onChange={this.handleChecked} value={this.state.eHmapaViagemPessoa} id="flexCheckDefault" checked={this.state.eHmapaViagemPessoa} />  
                    <label className='form-check-label' htmlFor='flexCheckDefault'>
                        Lista de Passageiros &nbsp;&nbsp;
                    </label>
                </div>
                <div className='form-check'>
                    <input className='form-check-input' type="checkbox" onChange={this.handleChecked} value={!this.state.eHmapaViagemPessoa} id="flexCheckChecked" checked={!this.state.eHmapaViagemPessoa} />  
                    <label className='form-check-label' htmlFor='flexCheckChecked'>
                        Lista de Encomendas
                    </label>
                </div>
            </React.Fragment>
        )
    }

    exibirBotoes() {
        return (
            <React.Fragment>
                <div className='row justify-content-md-end mt-2 col-md-12' id='printPageButton'>                    
                    <button className="vx-btn-primary ml-2" data-toggle="modal"
                        data-target="#modalImpressaoMapaViagemItinerario" onClick={() => this.habilitarDesabilitarModalReciboCupom(true)}>
                        <i className="material-icons mr-1" style={{ fontSize: '16px', verticalAlign: 'middle' }}>print</i>
                        Imprimir
                    </button>
                </div>
            </React.Fragment>)
    }

    exibir() {
        if (this.props.mapaViagem && this.props.mapaViagem.length) {
            return <div className='table-responsive'>
                <table className="table table-sm table-bordered table-striped text-center"
                    style={{ border: '1px solid #c8ced3' }}>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Trecho</th>
                            <th scope="col">Horário</th>
                            <th scope="col">KM(s)</th>
                            <th scope='col'>Sobem</th>
                            <th scope="col">Descem</th>
                            <th scope="col">Embarcados</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.exibirCorpoTabela()}
                    </tbody>
                    <tfoot style={{ backgroundColor: 'white' }}>
                        <tr>
                            <td colSpan={2}><strong>Qtd agências: {this.props.mapaViagem.length}</strong></td>
                            <td><strong>Totais</strong></td>
                            <td>{this.props.mapaViagem.map(it => it.quilometragem).reduce((sum, current) => Number(sum) + Number(current))}</td>
                            <td>{this.props.mapaViagem.map(it => it.quantidadeSobem).reduce((sum, current) => Number(sum) + Number(current))}</td>
                            <td>{this.props.mapaViagem.map(it => it.quantidadeDescem).reduce((sum, current) => Number(sum) + Number(current))}</td>
                            <td>{this.props.mapaViagem.map(it => it.quantidadeEmbarcados).reduce((sum, current) => Number(sum) + Number(current))}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        }
        return <div className="vx-gp-empty">Itinerário não possui passagens vendidas</div>
    }

    exibirEncomenda() {
        if (this.props.mapaViagemEncomenda && this.props.mapaViagemEncomenda.length) {
            return <div className='table-responsive'>
                <table className="table table-sm table-bordered table-striped text-center"
                    style={{ border: '1px solid #c8ced3' }}>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Trecho</th>
                            <th scope="col">Horário</th>
                            <th scope="col">KM(s)</th>
                            <th scope='col'>Sobem</th>
                            <th scope="col">Descem</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.exibirCorpoTabelaEncomenda()}
                    </tbody>
                    <tfoot style={{ backgroundColor: 'white' }}>
                        <tr>
                            <td colSpan={2}><strong>Qtd agências: {this.props.mapaViagemEncomenda.length}</strong></td>
                            <td><strong>Totais</strong></td>
                            <td>{this.props.mapaViagemEncomenda.map(it => it.quilometragem).reduce((sum, current) => Number(sum) + Number(current))}</td>
                            <td>{this.props.mapaViagemEncomenda.map(it => it.quantidadeSobem).reduce((sum, current) => Number(sum) + Number(current))}</td>
                            <td>{this.props.mapaViagemEncomenda.map(it => it.quantidadeDescem).reduce((sum, current) => Number(sum) + Number(current))}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        }
        return <div className="vx-gp-empty">Itinerário não possui encomendas vendidas</div>
    }

    exibirCorpoTabela() {
        return this.props.mapaViagem.map((mapa, index) => <tr key={`mapa-itinerario-${index}`}>
            <th scope="row">{index + 1}</th>
            <td>{mapa.trecho}</td>
            <td>{mapa.dataHoraSaida}</td>
            <td>{mapa.quilometragem}</td>
            <td>{mapa.quantidadeSobem}</td>
            <td>{mapa.quantidadeDescem}</td>
            <td>{mapa.quantidadeEmbarcados}</td>
        </tr>)
    }

    exibirCorpoTabelaEncomenda() {
        return this.props.mapaViagemEncomenda.map((mapa, index) => <tr key={`mapa-itinerario-${index}`}>
            <th scope="row">{index + 1}</th>
            <td>{mapa.trecho}</td>
            <td>{mapa.dataHoraSaida}</td>
            <td>{mapa.quilometragem}</td>
            <td>{mapa.quantidadeSobem}</td>
            <td>{mapa.quantidadeDescem}</td>
        </tr>)
    }

    exibirMapas() {
        if (this.state.eHmapaViagemPessoa) {
            return this.exibir()
        } else {
            return this.exibirEncomenda()
        }
    }

    getDescricaoRota() {
        if (this.props.rotaSelecionada && this.props.rotaSelecionada.value) {
            return <h1 id="titulo-page"
                        className="text-center">{this.props.rotaSelecionada ? `${this.props.rotaSelecionada.value}: ${this.props.rotaSelecionada.label}` : ''}</h1>
        }

        return <h1 id="titulo-page"
                    className="text-center">{this.props.itinerarioSelecionado.rotaDto ? `${this.props.itinerarioSelecionado.rotaDto.id}: ${this.props.itinerarioSelecionado.rotaDto.descricao}`: ''}
                </h1>
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getMotoristaEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="container-padrao">
                    <Titulo texto="Mapa de viagem" urlRetorno={this.state.retorno} />
                    {this.exibirCheckbox()}
                    {this.exibirBotoes()}
                    <div className="col-12 titulo-principal-componente mb-4">
                        {this.getDescricaoRota()}
                        <h4 id="titulo-page" className="text-center">{this.props.itinerarioSelecionado.dataHoraPartida}</h4>
                        {this.props.itinerarioSelecionado.prestador ?
                            <h4 id="titulo-page" className="text-center">Prestador: {this.props.itinerarioSelecionado.prestador.valor}<p className="linha"></p></h4> :
                            <h4 id="titulo-page" className="text-center"><p className="linha"></p></h4>
                        }
                    </div>
                    {this.exibirMapas()}
                    {this.apresentarReciboCupomTermica() && <div className="row col-12 printer-ticket">
                        <div style={{display: 'none'}}>
                            <ReciboMapaViagem
                                referencias={this.state.referencias}
                                rotaSelecionada={this.props.rotaSelecionada}
                                itinerarioSelecionado={this.props.itinerarioSelecionado}
                                eHmapaViagemPessoa={this.state.eHmapaViagemPessoa}
                                mapaViagem={this.props.mapaViagem}
                                mapaViagemEncomenda={this.props.mapaViagemEncomenda}
                            />
                        </div>
                    </div>}
                    <ModalImpressaoMapaViagemItinerario
                        referencias={this.state.referencias}
                        referenciaSelecionada={this.state.referenciaSelecionada}
                        pagina={this.state.pagina}
                        tipo={this.state.tipoImpressaoCupom}
                        setTipoImpressaoCupom={this.setTipoImpressaoCupom.bind(this)}
                        habilitarDesabilitarModalReciboCupom={this.habilitarDesabilitarModalReciboCupom.bind(this)}
                    />
                </div>                
            </Autorizacao>
        );
    }
}

export function mapStateToProps(state) {
    return {
        mapaViagem: state.mapaViagem.mapaViagem,
        mapaViagemEncomenda: state.mapaViagem.mapaViagemEncomenda,
        itinerarioSelecionado: state.itinerarioSelecionado,
        empresaSelecionada: state.empresaSelecionada,
        rotaSelecionada: state.rotaSelecionada
    }
}

export default connect(mapStateToProps, {
    buscarMapaViagem,
    buscarItinerario
})(PainelMapaViagemItinerario);
